import React from 'react';
import classNames from 'classnames';

import { PillVariant } from '../../types/enums';

import styles from './Pill.module.scss';

interface PillProps extends React.PropsWithChildren {
  variant: PillVariant;
}

const classNameByVariant = {
  [PillVariant.ERROR]: styles.pillError,
  [PillVariant.WARNING]: styles.pillWarning
};

const Pill = ({ children, variant }: PillProps) => {
  return <span className={classNames(styles.pill, classNameByVariant[variant])}>{children}</span>;
};

export default Pill;
